import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
/**
 * This component will be used to show custom tooltip
 *
 * This component will be rendered using OverlayModule of angular material
 * This component will be rendered by the directive on an Overlay
 *
 * CONSUMER will not be using this component directly
 * This component will be hosted in an overlay by ToolTipRenderer directive
 * This component exposes two properties. These two properties will be filled by ToolTipRenderer directive
 * 1. text - This is a simple string which is to be shown in the tooltip; This will be injected in the ToolTipRenderer directive
 *    by the consumer
 * 2. contentTemplate - This gives finer control on the content to be shown in the tooltip
 *
 * NOTE - ONLY one should be specified; If BOTH are specified then "template" will be rendered and "text" will be ignored
 */
@Component({
  selector: 'app-custom-tool-tip',
  templateUrl: './custom-tool-tip.component.html',
  styleUrls: ['./custom-tool-tip.component.scss'],
  animations: [
    trigger('customToolTipAnim', [
      transition(':enter', [style({ transform: 'scale(0.8)', opacity: 0 }), animate('.175s ease-out', style({ transform: 'scale(1)', opacity: 1 }))]),
      transition(':leave', [style({ transform: 'scale(1)', opacity: 1 }), animate('.2s ease-in', style({ transform: 'scale(0)', opacity: 0 }))]),
    ]),
  ],
})
export class CustomToolTipComponent implements OnInit {
  /**
   * This is simple text which is to be shown in the tooltip
   */
  @Input() text?: string;
  @Input() classList?: string;
  @Input() horizontalAnim: 'left' | 'center' | 'right' = 'center';
  @Input() verticalAnim: 'top' | 'center' | 'bottom' = 'center';

  /**
   * This provides finer control on the content to be visible on the tooltip
   * This template will be injected in ToolTipRenderer directive in the consumer template
   * <ng-template #template>
   *  content.....
   * </ng-template>
   */
  @Input() contentTemplate?: TemplateRef<any>;

  @Input() customTooltipDisabled?: boolean;

  constructor() {}

  ngOnInit() {}
}
